module.exports = __webpack_public_path__ + "static/media/empty-programme.1396108e.png";